export class Config {

    public relations = [];

    public names = {
        // therapist_id: function (data) {
        //     // return data.address && data.address.offname;
        // },
    }
}
